module.exports = __webpack_public_path__ + "assets/images/pdf-feature-440d67d81840fb19cd58022189a49ffa.png";